import React, { useState } from 'react';
import { message } from 'antd';
import { bubbleSetApi } from 'apis/platform/bubbleSetApis';
import DefaultInput from 'components/input/DefaultInput';
import DefaultModal from 'components/modal/DefaultModal';
import DefaultButton from 'components/button/DefaultButton';
import DefaultForm from 'components/form/DefaultForm';
import { useTranslation } from 'react-i18next';
/**
 * * 플랫폼 관리 - 말풍선 세트 등록
 */
const BubbleSetRegisterModal = ({ fetchData, visible, setVisible }) => {
  const { t } = useTranslation();
  const [inputData, setInputData] = useState({
    set_name: '',
    remark: '',
  });

  /// 모달 닫기
  const handleClose = () => {
    setInputData({ ...inputData, set_name: '', remark: '' });
    setVisible({ ...inputData, register: false });
  };

  /// input 변경
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };

  const handleSubmit = async () => {
    const res = await bubbleSetApi.register(inputData);
    if (!res) {
      return false;
    }
    setVisible(false);
    fetchData();
    message.success(t('bubble.registerBalloonModal.successMessage'), 1);
  };

  return (
    <DefaultModal
      title={t('bubble.registerBalloonModal.title')}
      visible={visible}
      onCancel={handleClose}
      footer={
        <DefaultButton onClick={handleSubmit}>
          {t('bubble.registerBalloonModal.register')}
        </DefaultButton>
      }
    >
      <DefaultForm>
        <DefaultInput
          title={t('bubble.registerBalloonModal.balloonName')}
          name='set_name'
          value={inputData.set_name}
          maxLength='35'
          onChange={handleInputChange}
          placeholder={t('bubble.registerBalloonModal.enterBalloonName')}
        />
        <DefaultInput
          title={t('bubble.registerBalloonModal.memo')}
          name='remark'
          value={inputData.remark}
          maxLength='35'
          onChange={handleInputChange}
          placeholder={t('bubble.registerBalloonModal.enterMemo')}
        />
      </DefaultForm>
    </DefaultModal>
  );
};

export default BubbleSetRegisterModal;
